export default __webpack_public_path__ + "media/images/icons_fc/factureblanc-ad0d996b014185aa241d85c139515b45.png";